var exports = {
  "k": "xdbfd91f1--37df12--container",
};

module.exports = exports;
